<template>
    <div class="shop__productprice" :class="ComputedClass">
        <div class="shop__productprice-block-icon">
            <img :src="CurrentTransaction.material.iconUrl" width="100" :alt="CurrentTransaction.material.name" />
        </div>
        <div class="shop__productprice-block-text">
            <div class="shop__productprice-product-name" v-html="migrolFormatText(CurrentTransaction.material.name)"></div>
            <div v-if="ShowAmount" class="shop__productprice-amount">{{Strings['Shop.DeliveryAmount']}}: {{position.amount|formatAmount}} {{UnitLabel}}</div>
            <div class="shop__material-price-loading" v-show="PricesLoading">
                <div class="shop__material-price-loading-ani-container">
                    <div class="shop__material-price-loading-ani"></div>
                </div>
                {{Strings['Shop.PriceCalculating']}}
            </div>
            <div v-if="PricesAvailable">
                <template v-if="ShowPricePerUnit">
                    <div class="shop__productprice-price">{{CurrentTransaction.material.getUnitPrice(position.id)|formatPrice}}<br/><span class="shop__productprice-price-unit">{{PricePerUnitLabel}}</span></div>
                    <div class="shop__productprice-price-secondary">{{Strings['Shop.Total']}}: {{CurrentTransaction.material.getTotalPrice(position.id)|formatPrice}}<br /><span class="shop__productprice-tax">{{Strings['Shop.InclTax']}}</span></div>
                </template>
                <template v-else>
                    <div class="shop__productprice-price">{{Strings['Shop.Price']}}: {{CurrentTransaction.material.getTotalPrice(position.id)|formatPrice}}<br /><span class="shop__productprice-tax">{{Strings['Shop.InclTax']}}</span></div>
                </template>                
            </div>
        </div>
        <div class="shop__productprice-block-myclimate" v-if="CurrentTransaction.myClimate">
            <img :src="Images['myClimateLogo']" style="width:120px;height:auto" />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { mapFilters } from '@/utils/vueFilters';
    import Transaction from '@/models/Transaction';
    import Price from '@/models/Price';

    export default {
        props: {
            position: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                default: '',
                required: false
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Images',
                'PricesLoading'
            ]),
            ComputedClass() {
                return this.type == '' ? '' : 'shop__productprice--' + this.type;
            },
            CurrentTransaction() {
                return Transaction.query().with('material').first();
            },
            PricesAvailable() {
                return Price.query().count() > 0;
            },
            IsSnAMaterial() {
                return this.CurrentTransaction.material.material == "Tankrevision" || this.CurrentTransaction.material.material == "Boilerentkalkung";
            },
            ShowAmount() {
                return !this.IsSnAMaterial;
            },
            ShowPricePerUnit() {
                return !this.IsSnAMaterial;
            },
            UnitLabel() {
                if (this.IsSnAMaterial)
                    return '';
                else if (this.CurrentTransaction.material.material == "Pellets")
                    return this.Strings['Shop.UnitsKg'];
                else
                    return this.Strings['Shop.UnitsLiter'];
            },
            PricePerUnitLabel() {
                if (this.IsSnAMaterial)
                    return '';
                else if (this.CurrentTransaction.material.material == "Pellets")
                    return this.Strings['Shop.For100Kg'];
                else
                    return this.Strings['Shop.For100Liter'];

            }
        },
        methods: {
            ...mapFilters([
                'migrolFormatText'
            ])
        }
    };
</script>